import { isEmpty, isNull, keys, pickBy } from 'lodash'
import * as moment from 'moment'
export const FORMAT_FILTER_DATE = 'YYYY-MM-DD HH:mm:ss'
export const FORMAT_DATE = 'YYYY-MM-DD'

export const getSimpleValue = (colObj) => {
  // filterType: text, number
  return [colObj.filter]
}

export const getDateValue = (colObj) => {
  const dateFrom = moment(colObj?.dateFrom, FORMAT_FILTER_DATE).format(
    FORMAT_DATE
  )
  const dateTo = colObj?.dateTo // '2022-07-06 00:00:00'

  return isNull(dateTo) ? [dateFrom] : [`[${dateFrom}, ${dateTo}]`]
}

export const getSetValue = (colObj, linksByUri) => {
  const values = colObj?.values ?? []

  if (!isEmpty(values)) {
    if (values[0].startsWith('ev://')) {
      const linkValues = values.map((value) => {
        return fromLinkToLabel(value, linksByUri)
      })
      return linkValues
    } else {
      return values
    }
  }
}

const fromLinkToLabel = (link, linksByUri) => {
  if (!link || isEmpty(link)) return ''

  const linkedDocByLink = pickBy(linksByUri, function (value, key) {
    return key === link
  })

  if (linkedDocByLink && !isEmpty(linkedDocByLink)) {
    return linkedDocByLink[link].title ?? ''
  }

  return ''
}

export const showActiveFilters = (columnsByModel, tableApi, linksByUri) => {
  if (isEmpty(columnsByModel)) return []
  const keyMap = keys(columnsByModel)
  if (isEmpty(keyMap)) return []

  return keyMap.reduce((acc, key) => {
    const colDef = columnsByModel[key]
    const type = colDef.filterType
    let objToReturn = {}

    switch (type) {
      case 'date':
        objToReturn = {
          [getLabel(key, tableApi)]: getDateValue(columnsByModel[key])
        }
        break

      case 'set':
        objToReturn = {
          [getLabel(key, tableApi)]: getSetValue(
            columnsByModel[key],
            linksByUri
          )
        }
        break

      default:
        objToReturn = {
          [getLabel(key, tableApi)]: getSimpleValue(columnsByModel[key])
        }
        break
    }

    return {
      ...acc,
      ...objToReturn
    }
  }, {})
}

const getLabel = (fieldId, tableApi) => {
  let fieldLabel = ''
  tableApi.gridCore.columnApi.columnController.columnDefs.forEach((element) => {
    if (element?.field === fieldId) {
      fieldLabel = element.headerName ?? element?.field
    }
  })

  return fieldLabel
}
